





















































































































































































import Vue from 'vue'
import { mask } from 'vue-the-mask'
import {
  carAgencyController,
  carCategoryController,
  carContractController,
  carOfficeController,
  carSeasonsController,
  changeCarContractStatus,
} from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import DateTimePicker from '~/components/DateTimePicker.vue'
import RangeDatePicker from '~/components/RangeDatePicker.vue'
import ShareContractButton from '~/components/Services/Cars/ShareContractButton.vue'
import TextButton from '~/components/TextButton.vue'
import { DatePicker, TableHeader } from '~/utils/interfaces'
import { CarContract, CreateCarContract } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: {
    AppView,
    Autocomplete,
    DateTimePicker,
    ShareContractButton,
    TextButton,
    RangeDatePicker,
  },
  directives: {
    mask,
  },
  data() {
    return {
      controller: carContractController,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        // {
        //   text: this.$t('agency.agency'),
        //   value: 'agency_name',
        // },
        {
          text: this.$t('car_agency'),
          value: 'car_agency_name',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarContract>[],
      defaultCrud: {
        agency: this.$store.state.profile.agency,
        car_agency: '',
        description: '',
        name: '',
        start_date: '',
        end_date: '',
        offices: [],
        prices: [
          {
            category: '',
            cost: '',
            max_days: '',
            min_days: 1,
            price: '',
            season: '',
          },
        ],
      },
      defaultCarContractPrice: {
        category: '',
        cost: '',
        price: '',
        max_days: 1,
        min_days: 0,
        season: '',
      },
    }
  },
  methods: {
    getCarAgencies: carAgencyController.getter,
    getCarOffices: carOfficeController.getter,
    getCarCategories: carCategoryController.getter,
    getCarSeason: carSeasonsController.getter,
    addContractPrice(crud: CreateCarContract) {
      crud.prices.push({ ...this.defaultCarContractPrice })
    },
    toggle: changeCarContractStatus,
    serializeFilter(filter: Record<string, string>) {
      const startDate = (this.$refs.startDate as DatePicker).getData()
      const endDate = (this.$refs.startDate as DatePicker).getData()
      return {
        ...filter,
        start_date__lte: startDate.maxDate,
        end_date__lte: endDate.maxDate,
        start_date__gte: startDate.minDate,
        end_date__gte: endDate.minDate,
      }
    },
  },
})
